import React, { useState } from "react";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { CreateAd } from "../../../pages/MoneyEx/MoneyExAds";
import { MoneyExController } from "../../../controllers";

const CreateAdContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    username: yup.string().required("Username is required"),

    from: yup.string().required("From field is required"),

    to: yup.string().required("To field is required"),

    rate: yup
      .number()
      .required("Rate is required")
      .min(0, "Rate cannot be negative"),

    availableAmount: yup
      .number()
      .required("Available amount is required")
      .min(0, "Available amount cannot be negative"),

    minPerSale: yup
      .number()
      .required("Minimum per sale is required")
      .min(0, "Minimum per sale cannot be negative"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    console.log("line 36");
    const payload = {
      username: values.username,
      from: values.from,
      to: values.to,
      rate: values.rate,
      availableAmount: values.availableAmount,
      minPerSale: values.minPerSale,
    };
    console.log("payload", payload);
    const { status, errorMessage } = await MoneyExController.createAd(payload);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];
  return (
    <CreateAd
      loading={loading}
      currencyCodes={currencyCodes}
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    />
  );
};
export default CreateAdContainer;
